/* eslint-disable react/prop-types */
import React from "react";
import { useSelector } from "react-redux";
import { Switch, useLocation, Route, useRouteMatch } from "react-router-dom";
import clsx from "clsx";
import { Drawer, Divider, IconButton, makeStyles } from "@material-ui/core/";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import CssBaseline from "@material-ui/core/CssBaseline";
import EstimationsParentComponent from "app/estimations/EstimationsParentComponent";
import ScenarioSidebarComponent from "app/scenarios/ScenarioSidebarComponent";
import FiltersComponent from "app/filters/FiltersComponent";
import HistoryComponent from "app/history/HistoryComponent";
import ElasticityComponent from "app/elasticity/ElasticityComponent";
import CompetitorsComponent from "app/competitors/CompetitorsComponent";
import CompetitorsOldComponent from "app/competitorsOld/CompetitorsOldComponent";
// import ConsentDialogComponent from "app/auth/utils/ConsentDialogComponent";
import DemandPlanningComponent from "app/demand/DemandPlanningComponent";

const drawerWidth = 260;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    backgroundColor: "#ffffff",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    paddingRight: "0px",
    backgroundColor: "#fafafa",
    zIndex: 1,
    [theme.breakpoints.down("xs")]: {
      marginLeft: "0px",
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0px",
    },
    [theme.breakpoints.up("md")]: {
      marginLeft: "0px",
    },
    [theme.breakpoints.up("lg")]: {
      marginLeft: "70px",
    },
  },
  paperAnchorDockedLeft: {
    borderRight: "none",
  },
  content: {
    flexGrow: 1,
    marginLeft: -drawerWidth,
    overflow: "hidden",
  },
  mainContent: {
    backgroundColor: "white",
    display: "flex",
    flexFlow: "column",
    height: "100vh",
    overflow: "auto",
    padding: "8px",
    borderLeft: "1px solid #d2d2d2",
    [theme.breakpoints.up("xs")]: {
      marginRight: "0px",
    },
    [theme.breakpoints.up("sm")]: {
      marginRight: "0px",
    },
    [theme.breakpoints.up("md")]: {
      marginRight: "0px",
    },
  },
  contentShift: {
    marginLeft: "-20px",
  },
  toggleExpandIcon: {
    position: "fixed",
    zIndex: "3",
    border: "1px solid #e2e2e2",
    padding: "0px",
    marginLeft: "-13px",
    marginTop: "46px",
    backgroundColor: "#ffffff",
    "&:hover": {
      backgroundColor: "#D45F59",
      color: "#ffffff",
    },
  },
  iconOpen: {
    marginLeft: "-13px",
  },
}));

function PersistentDrawerLeft() {
  // { confirmDialogOpen, handleDialogClose }
  const classes = useStyles();
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const { url, path } = useRouteMatch();
  const configCatSlice = useSelector((state) => state.auth.configCatUser);
  const IsOldCompetitors = configCatSlice?.features.IsOldCompetitors;

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  return (
    <div className={classes.root}>
      {/* <ConsentDialogComponent
        open={confirmDialogOpen}
        handleClose={handleDialogClose}
      /> */}
      <CssBaseline />
      <Drawer
        className={classes.drawer}
        transitionDuration={0}
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawerPaper,
          paperAnchorDockedLeft: classes.paperAnchorDockedLeft,
        }}
      >
        {location.pathname === `${url}` ||
        location.pathname === `${url}/pricing` ? (
          <>
            <ScenarioSidebarComponent />
            <Divider />
          </>
        ) : (
          ""
        )}
        <FiltersComponent />
      </Drawer>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        <IconButton
          className={
            open
              ? `${classes.toggleExpandIcon} ${classes.iconOpen}`
              : `${classes.toggleExpandIcon}`
          }
          onClick={handleDrawerToggle}
        >
          {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
        <div>
          <div className={classes.mainContent}>
            <Switch>
              <Route
                exact
                path={`${path}`}
                component={EstimationsParentComponent}
              />
              <Route
                exact
                path={`${path}/pricing`}
                component={EstimationsParentComponent}
              />
              <Route
                exact
                path={`${path}/history`}
                component={HistoryComponent}
              />
              <Route
                exact
                path={`${path}/elasticity`}
                component={ElasticityComponent}
              />
              {IsOldCompetitors ? (
                <Route
                  exact
                  path={`${path}/competitors`}
                  component={CompetitorsOldComponent}
                />
              ) : (
                <Route
                  exact
                  path={`${path}/competitors`}
                  component={CompetitorsComponent}
                />
              )}
              <Route
                exact
                path={`${path}/demand`}
                component={DemandPlanningComponent}
              />
            </Switch>
          </div>
        </div>
      </main>
    </div>
  );
}

export default PersistentDrawerLeft;
